export default __webpack_public_path__ + "static/media/stoly2.22c31301.jpg";